const header = {
    namespaced : true,
    state : {
        mobile: false,
        totalComment: 0,
        totalCourseOnline: 0,
        history: null
    },
    mutations : {
        setMobile(state, payload) {
            state.mobile = payload
        },
        setTotalComment(state, payload) {
            state.totalComment = payload
        },
        setTotalCourseOnline(state, payload) {
            state.totalCourseOnline = payload
        },
        setHistory(state, payload) {
            state.history = payload
        }
    },
    getters : {
        mobile (state) {
            return state.mobile
        },
        getTotalComment(state) {
            return state.totalComment
        },
        getTotalCourseOnline(state) {
            return state.totalCourseOnline
        },
        getHistory(state) {
            return state.history
        }
    }
};

export default header;


// WEBPACK FOOTER //
// ./src/stores/modules/header.js